module.exports = __webpack_public_path__ + "static/media/feature-1.fba5905f.svg";